import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Card from '~/components/cards/Card.vue';
import Follow from '~/components/profile/Follow.vue';
import DdButton from '~/components/DdButton.vue';
import WebpPicture from '~/components/WebpPicture.vue';
export default {
  components: {
    Card: Card,
    Follow: Follow,
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    DdButton: DdButton,
    WebpPicture: WebpPicture
  },
  props: ['profile', 'followers'],
  data: function data() {
    return {
      socialNumber: 5,
      profileSocials: [],
      socials: [{
        name: 'facebook',
        icon: 'icon-ic-facebook-circle',
        title: 'Facebook'
      }, {
        name: 'linkedin',
        icon: 'icon-ic-linkedin',
        title: 'LinkedIn'
      }, {
        name: 'behance',
        icon: 'icon-ic-behance',
        title: 'Behance'
      }, {
        name: 'instagram',
        icon: 'icon-ic-instagram',
        title: 'Instagram'
      }, {
        name: 'dribbble',
        icon: 'icon-ic-dribbble',
        title: 'Dribbble'
      }, {
        name: 'telegram',
        icon: 'icon-ic-telegram-logo',
        title: 'Telegram'
      }, {
        name: 'youtube',
        icon: 'icon-ic-play-button',
        title: 'YouTube'
      }]
    };
  },
  created: function created() {
    var _this = this;
    var result = [];
    this.socials.forEach(function (social) {
      if (_this.profile[social.name]) {
        result.push({
          name: social.name,
          icon: social.icon,
          title: social.title,
          link: _this.profile[social.name]
        });
      }
    });
    this.profileSocials = result;
  },
  computed: {
    type: function type() {
      return this.profile.type;
    },
    interestKey: function interestKey() {
      return this.type == 'company' ? 'companies' : 'specialists';
    },
    location: function location() {
      var location = '';
      if (this.profile.country) location = this.profile.country;
      if (this.profile.city) {
        if (location.length) location = "".concat(location, ", ");
        location = "".concat(location).concat(this.profile.city);
      }
      return location;
    },
    visibleSocials: function visibleSocials() {
      var trimIndex = this.profileSocials.length <= this.socialNumber ? this.socialNumber : this.socialNumber - 1;
      return this.profileSocials.slice(0, trimIndex);
    },
    hiddenSocials: function hiddenSocials() {
      if (this.profileSocials.length <= this.socialNumber) return [];
      var trimIndex = 0 - 1 - this.profileSocials.length + this.socialNumber;
      return this.profileSocials.slice(trimIndex);
    },
    readersOpen: function readersOpen() {
      return this.$modalityStore.drawer == 'usersList' && this.usersListStore.id == "subs-".concat(this.profile.id);
    },
    usersListStore: function usersListStore() {
      return useUsersListStore();
    }
  },
  methods: {
    showSubscribers: function showSubscribers() {
      this.usersListStore.update({
        id: "subs-".concat(this.profile.id),
        url: '/user/getsubscribers',
        title: 'readers',
        params: {
          model: this.type,
          id: this.profile.id
        }
      });
    },
    cleanLink: function cleanLink(link) {
      return link.replace(/^(https?:\/\/)?(www\.)?/i, '');
    }
  }
};